import { render } from "./ThePanelSubmenu.vue?vue&type=template&id=86e729a6"
import script from "./ThePanelSubmenu.vue?vue&type=script&lang=js"
export * from "./ThePanelSubmenu.vue?vue&type=script&lang=js"
script.render = render

export default script